import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// One-shot module-level cache so we don't hit the API on every page nav.
let _cache = null;
let _inflight = null;

/**
 * Fetch the editable site content (footer fields, hero, etc.).
 * Cached in module scope for the session — re-fetches only on full reload.
 */
export function useContent() {
  const [content, setContent] = useState(_cache);

  useEffect(() => {
    if (_cache) return;
    if (!_inflight) {
      _inflight = axios.get(`${API}/content`).then((r) => {
        _cache = r.data || {};
        return _cache;
      }).catch(() => ({}));
    }
    _inflight.then((d) => setContent(d));
  }, []);

  return content || {};
}
